<template>
  <header class="site-header">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <a
          class="navbar-brand"
          href="/"
          title="SCS Application Portal"
          aria-label="SCS Application Portal"
        >
          <SiteLogoText height="40" />
        </a>
        <EnvBadge />

        <SiteNavigation />
      </div>
    </nav>
  </header>
</template>

<script setup>
import EnvBadge from '@shared/components/EnvBadge.vue'
import SiteNavigation from '@shared/components/SiteNavigation.vue'
import SiteLogoText from './SiteLogoText.vue'
</script>
